import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './dashboard-wrap.styl'

export default class DashboardWrap extends Component {
  static propTypes = {
    children: PropTypes.array,
  }

  render() {
    return (
      <div className={styles.wrap}>
        <div className={styles.inner}>
          {this.props.children}
        </div>
      </div>
    )
  }
}
